import { useContext } from 'react'

import { BadgeCreateContext } from '../providers/BadgeCreateProvider/BadgeCreateProvider'

export const useBadgeCreateContext = () => {
  const badgeCreateContext = useContext(BadgeCreateContext)

  if (badgeCreateContext === undefined) {
    throw new Error('badgeCreateContext must be used within a BadgeCreateProvider')
  }

  return badgeCreateContext
}
